{
  "pt": {
    "client": {
      "actions": {
        "changeBackgroundImage": "Alterar imagem de início de sessão",
        "new": "Novo cliente",
        "setAsPrimary": "Definir como principal",
        "submit": "Enviar",
        "undoChanges": "Anular alterações"
      },
      "attributes": {
        "address": "Endereço",
        "aftercare_conversation_enabled": "Conversas de pós-venda",
        "backgroundImage": "Imagem do ecrã de início de sessão",
        "email_address": "E-mail",
        "email_address_invoicing": "E-mail de faturação",
        "email_address_renewal": "E-mail de lembrete de renovação de contrato",
        "email_address_reply_to": "\"Responder a\" Endereço de E-mail",
        "email_address_ziggu": "\"De\" Endereço de E-mail",
        "iban": "IBAN",
        "language": "Língua",
        "languages": "Línguas da empresa",
        "name": "Nome",
        "phone": "Telefone",
        "storage_sum": "Utilização do armazenamento",
        "storage_sum_max": "{percentage}% de {gigabytes} GB",
        "subdomain": "Subdomínio",
        "timezone": "Fuso horário",
        "vat_number": "Número de IVA"
      },
      "client_types": {
        "architects_designers": "Arquitetos e Designers",
        "creative_agencies": "Agências criativas",
        "general_specialized_contractors": "Empreiteiros gerais e especializados",
        "makers_manufacturers": "Produtores e fabricantes",
        "planners_coordinators": "Planeadores e coordenadores",
        "property_developers": "Promotores imobiliários"
      },
      "integrations": {
        "api_docs_info": "Para mais informações sobre a nossa API, consulte a nossa",
        "api_documentation": "documentação da API"
      },
      "labels": {
        "activeProjects": "Projetos ativos",
        "activeProjectsUsed": "{0} projetos ativos, {1} ainda não utilizado",
        "activeUnits": "Unidades ativas",
        "activeUnitsUsed": "{0} unidades ativas, {1} ainda não utilizado",
        "after_care_categories": "Categorias",
        "after_care_statuses": "Estados",
        "aftercare": "Pós-venda",
        "bookADemo": "Agendar uma demonstração",
        "by": "Por {client}",
        "categories": "Categorias",
        "category": "Categoria",
        "chatWithUs": "Conversar connosco",
        "companyProfile": "Perfil da empresa",
        "contactIntercom": "Contacte-nos através do chat se pretender alterar esta situação.",
        "contactZiggu": "Tem uma pergunta para o Ziggu? Tem alguma dúvida? Conselhos sobre produtos? Vamos conversar!",
        "conversations": "Conversas",
        "dashboard": "Painel de controlo",
        "decisions": "Decisões",
        "default_payment_overdue": "Tem uma fatura em atraso relativa ao Ziggu. Pague-a imediatamente para evitar juros. Tem alguma dúvida? Não hesite em contactar-nos.",
        "delete_category": "Eliminar a categoria {category}?",
        "delete_category_expl": "A eliminação da categoria de documento não pode ser anulada. Os documentos existentes com esta categoria serão alterados para a categoria Outros",
        "document_categories": "Categorias",
        "documents": "Documentos",
        "email_address_invoicing_info": "As novas faturas serão enviadas para este endereço.",
        "email_address_renewal_info": "Enviaremos mensagens de e-mail para o endereço quando a data de renovação da sua subscrição estiver próxima e gostaríamos de o informar sobre a mesma, juntamente com todas as informações necessárias.",
        "email_address_reply_to": "Este endereço de e-mail será utilizado se alguém responder a uma mensagem de e-mail enviada através de {email_address_ziggu}. Contacte-nos através do chat se pretender alterar este endereço.",
        "email_address_ziggu": "Este endereço de e-mail será utilizado como endereço DE de todas as mensagens de e-mail enviadas através da plataforma (mensagens relativas a notificações, convites, redefinições de palavra-passe, ...)",
        "email_forwarder_must_be_owner": "Apenas os membros da equipa com a função \"Proprietário\" podem reencaminhar mensagens de e-mail.",
        "email_forwarding_activated": "O reencaminhamento de e-mail está ativo",
        "email_forwarding_activated_project": "O reencaminhamento de e-mail do projeto está ativo",
        "email_forwarding_disclaimer": "Para evitar spam, só são processadas as mensagens de e-mail enviadas de um endereço associado a um <b>perfil de Proprietário/Mantenedor existente</b>.<br>As mensagens de e-mail de remetentes desconhecidos serão ignoradas.",
        "email_forwarding_is": "O seu endereço de reencaminhamento é:",
        "financials": "Finanças",
        "general": "Geral",
        "goToSettings": "Definições",
        "helpcenter": "Centro de ajuda",
        "inbound_email": "E-mail de entrada",
        "invoice_overdue": "Tem um pagamento em atraso. Para mais informações, contacte accounting{'@'}ziggu.io.",
        "invoice_overdue_title": "Fatura vencida",
        "language": "Esta é a língua predefinida da empresa para a sua página de início de sessão, clientes e membros da equipa.",
        "languages": "A língua principal é a predefinida para a introdução de conteúdo e não pode ser removida. Adicione línguas adicionais para suportar conteúdo multilingue. Clique em qualquer língua adicional para a tornar a principal.",
        "mobile_app_disabled": "Aplicação móvel (PWA) não ativa",
        "mobile_app_enabled": "Aplicação móvel (PWA) ativa",
        "mobile_app_info": "Para mais informações, envie-nos uma mensagem através do Intercom!",
        "mustBeJPG": "Deve ser uma imagem .jpg",
        "new_categories": "Categorias extra",
        "new_document_category": "Categoria",
        "noCategories": "Ainda não tem nenhuma categoria. Crie uma para começar.",
        "other": "Outros",
        "outOfOffice": "Ausência",
        "outOfOfficeMessage": "Mensagem de ausência (opcional)",
        "packageUnits": "Subscrito para",
        "primary": "Principal",
        "removed_user": "Utilizador removido",
        "settings": {
          "click_to_copy": "Clique para copiar o token para a área de transferência",
          "copied_to_clipboard": "Token copiado para a área de transferência"
        },
        "snippets": "Trechos",
        "subscription": "Subscrição",
        "subscriptionRenewalDate": "Data de renovação",
        "subscriptionUsageUnits": "Utilização atual",
        "tab_aftercare": "Pós-venda",
        "tab_billing": "Faturação",
        "tab_branding": "Identidade visual",
        "tab_features": "Funcionalidades",
        "tab_general": "Geral",
        "tab_information": "Informações",
        "tab_integrations": "Integrações",
        "tickets": "Conversas",
        "timezone": "Este é o fuso horário predefinido da empresa.",
        "translation_not_added_yet": "A tradução ainda não foi adicionada",
        "unchangeable_categories": "Categorias por defeito que são inalteráveis",
        "unchangeable_categories_info": "Essas categorias são necessárias para o funcionamento adequado do sistema ou estão a ser usadas em integrações.",
        "upgradePackageContactUs": "Contacte-nos para começar",
        "upgradePackageSubtitleAftercare": "Esta funcionalidade permitir-lhe-á acompanhar os clientes após a entrega e ajudá-los a resolver quaisquer problemas com a sua nova casa",
        "upgradePackageSubtitleConversationMentions": "Esta funcionalidade permite-lhe escrever notas privadas e marcar membros da equipa numa conversa",
        "upgradePackageSubtitleFinancials": "Criar uma panorâmica financeira para cada comprador num instante",
        "upgradePackageSubtitleMilestones": "Esta funcionalidade permite-lhe comunicar o progresso da construção de uma forma fácil ao seu cliente",
        "upgradePackageSubtitleMultipleCustomerSingleUnit": "Esta funcionalidade permite-lhe convidar um segundo comprador de casa para a plataforma Ziggu",
        "upgradePackageTitle": "Parece que ainda não tem esta funcionalidade",
        "warningooo": "Ausência ativa",
        "yourEmail": "O seu e-mail",
        "zigguHome": "Início Ziggu"
      },
      "project_types": {
        "mup": "MUPs",
        "mup_and_sup": "MUPs e SUPs",
        "sup": "SUPs"
      },
      "toasts": {
        "attachment_category": {
          "create": "Categoria de documento criada",
          "update": "A categoria do documento foi atualizada"
        }
      },
      "validation": {
        "attachment_category_required": "A categoria é obrigatória",
        "duplicated_translation": "Tradução duplicada",
        "mustBeEmailAddress": "Deve ser um endereço de e-mail",
        "needName": "O nome é obrigatório"
      }
    }
  }
}
